<template>
  <div class="youtube-video">
    <div class="youtube-video-wrapper">
      <iframe height="315" :src="videoEmbedUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YoutubeVideo',

  props: {
    url: String
  },

  computed: {
    videoEmbedUrl() {
      let videoId = this.url.split('v=')[1]
      let ampersandPosition = videoId.indexOf('&')

      if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition)
      }

      return `https://www.youtube.com/embed/${videoId}`
    }
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/helpers/mixins'

.youtube-video
  margin-bottom: $gap-small

  @include media($media-gt-small)
    margin: 0

.youtube-video-wrapper
  position: relative
  padding-bottom: 56.25%
  height: 0

  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    border-radius: 0
</style>
